const VIDEO_LIST_REQUEST = "videoList/REQUEST";
const VIDEO_LIST_SUCCESS = "videoList/SUCCESS";
const VIDEO_LIST_FAILURE = "videoList/FAILURE";
const VIDEO_LIST_RESET = "videoList/RESET";
const VIDEO_LIST_ADD = "videoList/ADD";

export default {
  VIDEO_LIST_REQUEST,
  VIDEO_LIST_SUCCESS,
  VIDEO_LIST_FAILURE,
  VIDEO_LIST_RESET,
  VIDEO_LIST_ADD,
};
